// The library card's words and arithmetic (PLAN.md §Profiles as library cards), for the web's card and the app's:
// how a stamp is dated and read aloud, twelve stamps to a card, and whose stamps a card holds.
import { STAMPS_PER_CARD } from "./index.js";
import { libraryCard as txt, profile as ptxt } from "./copy/account.js";
const MONTHS = [txt.jan, txt.feb, txt.mar, txt.apr, txt.may, txt.jun, txt.jul, txt.aug, txt.sep, txt.oct, txt.nov, txt.dec];
/** "12 NOV 2026" as stamped, or the year alone for a book read before Pagemates. */
export const stampDate = (s) => {
    const d = new Date(s.at);
    return s.kind === "back" ? String(d.getFullYear()) : `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
};
export const longDate = (iso) => new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" });
export const monthYear = (iso) => new Date(iso).toLocaleDateString(undefined, { month: "short", year: "numeric" });
/** "Slaughterhouse-Five, finished 12 November 2026, 4 stars." */
export function spokenStamp(s) {
    const stars = s.halfStars ? `, ${s.halfStars / 2} ${s.halfStars === 2 ? txt.star : txt.stars}` : "";
    if (s.kind === "dnf")
        return txt.returnedUnfinished(s.book.title, longDate(s.at));
    if (s.kind === "back")
        return txt.readIn(s.book.title, new Date(s.at).getFullYear(), stars);
    return txt.finished(s.book.title, longDate(s.at), stars);
}
/** Twelve to a card; always at least one (empty) card. */
export function chunkCards(stamps) {
    const cards = [];
    for (let i = 0; i < stamps.length; i += STAMPS_PER_CARD)
        cards.push(stamps.slice(i, i + STAMPS_PER_CARD));
    return cards.length ? cards : [[]];
}
/** "3 clubs", or the one club's name, or nothing: whose stamps these are. */
export function clubLine(card) {
    const names = new Set(card.stamps.map((s) => s.club?.name ?? s.clubName ?? null));
    const known = [...names].filter(Boolean);
    if (known.length === 0)
        return null;
    if (names.size === 1)
        return known[0];
    return ptxt.clubs(names.size);
}
//# sourceMappingURL=stamps.js.map